/* ============================================
   SHAJAR — Theme enhancements
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {
  wrapHeroHeading();
  initCardActions();
  initCountdowns();
  initStickyAtc();
  initFomo();
  /* Judge.me Next unlock only when write-review UI exists (product pages) */
  if (document.querySelector('[data-shajar-write-review-btn], .jdgm-write-rev-link, .jdgm-widget')) {
    initJudgeMeReviewUnlock();
  }
});

document.addEventListener('shopify:section:load', function (event) {
  if (event.target && event.target.querySelector && event.target.querySelector('[data-shajar-fomo]')) {
    initFomo();
  }
  if (event.target && event.target.querySelector && event.target.querySelector('[data-shajar-sticky-atc]')) {
    initStickyAtc();
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  if (event.target && event.target.querySelector && event.target.querySelector('[data-shajar-sticky-atc]')) {
    destroyStickyAtc();
  }
});

/* ---------- Mobile sticky Add to Cart ---------- */
var shajarStickyAtcCleanup = null;

function destroyStickyAtc() {
  if (typeof shajarStickyAtcCleanup === 'function') {
    shajarStickyAtcCleanup();
    shajarStickyAtcCleanup = null;
  }
}

function initStickyAtc() {
  destroyStickyAtc();

  var bar = document.querySelector('[data-shajar-sticky-atc]');
  if (!bar) return;

  var sectionId = bar.getAttribute('data-section-id');
  if (!sectionId) return;

  var sentinel = document.getElementById('ProductSubmitButton-' + sectionId);
  var mainPrice = document.getElementById('price-' + sectionId);
  var stickyPrice = bar.querySelector('[data-sticky-price]');
  var stickyBtn = bar.querySelector('[data-sticky-submit]');
  var intersectionObserver = null;
  var mutationObserver = null;

  function setBarVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    document.body.classList.toggle('shajar-sticky-atc-active', visible);

    if (visible) {
      bar.removeAttribute('aria-hidden');
      bar.removeAttribute('inert');
      if (stickyBtn) stickyBtn.removeAttribute('tabindex');
      document.documentElement.style.setProperty(
        '--shajar-sticky-atc-offset',
        bar.offsetHeight + 'px'
      );
    } else {
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
      if (stickyBtn) stickyBtn.setAttribute('tabindex', '-1');
      document.documentElement.style.removeProperty('--shajar-sticky-atc-offset');
    }
  }

  function syncFromMain() {
    if (mainPrice && stickyPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }
    if (sentinel && stickyBtn) {
      stickyBtn.disabled = sentinel.hasAttribute('disabled');
      var stickyLabel = stickyBtn.querySelector('span');
      var mainLabel = sentinel.querySelector('span');
      if (stickyLabel && mainLabel) {
        stickyLabel.textContent = mainLabel.textContent.trim();
      }
    }
    if (bar.classList.contains('is-visible')) {
      document.documentElement.style.setProperty(
        '--shajar-sticky-atc-offset',
        bar.offsetHeight + 'px'
      );
    }
  }

  setBarVisible(false);
  syncFromMain();

  if ('IntersectionObserver' in window && sentinel) {
    intersectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setBarVisible(!entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );
    intersectionObserver.observe(sentinel);
  }

  if ('MutationObserver' in window && (sentinel || mainPrice)) {
    mutationObserver = new MutationObserver(syncFromMain);
    if (sentinel) {
      mutationObserver.observe(sentinel, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    if (mainPrice) {
      mutationObserver.observe(mainPrice, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class'],
      });
    }
  }

  shajarStickyAtcCleanup = function () {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = null;
    }
    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = null;
    }
    setBarVisible(false);
  };
}

function wrapHeroHeading() {
  if (!document.body.classList.contains('template-index')) return;

  var heroSection = document.querySelector('#MainContent > .shopify-section:first-child');
  var heroHeading = heroSection
    ? heroSection.querySelector('.banner__heading')
    : null;
  if (!heroHeading || heroHeading.dataset.shajarWrapped) return;

  var originalText = heroHeading.textContent.trim();
  if (!originalText) return;

  var parts = originalText.split(',');
  var fragment = document.createDocumentFragment();

  if (parts.length > 1) {
    parts.forEach(function (part, i) {
      var span = document.createElement('span');
      span.className = 'shajar-line';
      span.textContent = part.trim() + (i < parts.length - 1 ? ',' : '');
      fragment.appendChild(span);
    });
  } else {
    var span = document.createElement('span');
    span.className = 'shajar-line';
    span.textContent = originalText;
    fragment.appendChild(span);
  }

  heroHeading.replaceChildren(fragment);
  heroHeading.dataset.shajarWrapped = 'true';

  if (heroSection) {
    heroSection.classList.add('shajar-hero-ready');
  }
}

/* ---------- Wishlist / Compare (localStorage) ---------- */
var SHAJAR_WISHLIST_KEY = 'shajar_wishlist';
var SHAJAR_COMPARE_KEY = 'shajar_compare';
var SHAJAR_COMPARE_MAX = 4;

function readStore(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]');
  } catch (e) {
    return [];
  }
}

function writeStore(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function productPayload(btn) {
  return {
    handle: btn.getAttribute('data-product-handle'),
    id: btn.getAttribute('data-product-id'),
    title: btn.getAttribute('data-product-title'),
    url: btn.getAttribute('data-product-url'),
    image: btn.getAttribute('data-product-image')
  };
}

function toggleInStore(key, item, max) {
  var list = readStore(key);
  var index = list.findIndex(function (entry) {
    return entry.handle === item.handle;
  });
  var added = false;

  if (index > -1) {
    list.splice(index, 1);
  } else {
    if (max && list.length >= max) {
      list.shift();
    }
    list.push(item);
    added = true;
  }

  writeStore(key, list);
  return { list: list, added: added };
}

function syncActionButtons() {
  var wishlist = readStore(SHAJAR_WISHLIST_KEY);
  var compare = readStore(SHAJAR_COMPARE_KEY);

  document.querySelectorAll('[data-shajar-action="wishlist"]').forEach(function (btn) {
    var active = wishlist.some(function (item) {
      return item.handle === btn.getAttribute('data-product-handle');
    });
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  });

  document.querySelectorAll('[data-shajar-action="compare"]').forEach(function (btn) {
    var active = compare.some(function (item) {
      return item.handle === btn.getAttribute('data-product-handle');
    });
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  });

  updateUtilBar(compare);
}

function ensureUtilBar() {
  var bar = document.getElementById('shajar-util-bar');
  if (bar) return bar;

  bar = document.createElement('div');
  bar.id = 'shajar-util-bar';
  bar.className = 'shajar-util-bar';
  bar.setAttribute('role', 'status');
  bar.innerHTML =
    '<span class="shajar-util-bar__text" data-text></span>' +
    '<button type="button" class="shajar-util-bar__btn" data-compare-open>Compare</button>' +
    '<button type="button" class="shajar-util-bar__clear" data-compare-clear>Clear</button>';
  document.body.appendChild(bar);

  bar.querySelector('[data-compare-clear]').addEventListener('click', function () {
    writeStore(SHAJAR_COMPARE_KEY, []);
    syncActionButtons();
    closeCompareDrawer();
  });

  bar.querySelector('[data-compare-open]').addEventListener('click', openCompareDrawer);

  return bar;
}

function ensureCompareDrawer() {
  var drawer = document.getElementById('shajar-compare-drawer');
  if (drawer) return drawer;

  drawer = document.createElement('div');
  drawer.id = 'shajar-compare-drawer';
  drawer.className = 'shajar-compare-drawer';
  drawer.innerHTML =
    '<div class="shajar-compare-drawer__panel" role="dialog" aria-modal="true" aria-label="Compare products">' +
    '<div class="shajar-compare-drawer__head"><h2>Compare</h2>' +
    '<button type="button" class="shajar-util-bar__clear" data-compare-close>Close</button></div>' +
    '<div class="shajar-compare-drawer__grid" data-compare-grid></div></div>';
  document.body.appendChild(drawer);

  drawer.addEventListener('click', function (event) {
    if (event.target === drawer || event.target.closest('[data-compare-close]')) {
      closeCompareDrawer();
    }
  });

  return drawer;
}

function openCompareDrawer() {
  var list = readStore(SHAJAR_COMPARE_KEY);
  if (!list.length) return;
  var drawer = ensureCompareDrawer();
  var grid = drawer.querySelector('[data-compare-grid]');
  grid.innerHTML = list
    .map(function (item) {
      return (
        '<div class="shajar-compare-drawer__item">' +
        (item.image ? '<img src="' + item.image + '" alt="" width="240" height="240" loading="lazy">' : '') +
        '<a href="' + item.url + '">' + item.title + '</a></div>'
      );
    })
    .join('');
  drawer.classList.add('is-open');
}

function closeCompareDrawer() {
  var drawer = document.getElementById('shajar-compare-drawer');
  if (drawer) drawer.classList.remove('is-open');
}

function updateUtilBar(compareList) {
  var bar = ensureUtilBar();
  var text = bar.querySelector('[data-text]');
  if (!compareList.length) {
    bar.classList.remove('is-visible');
    return;
  }
  text.textContent = compareList.length + ' product' + (compareList.length > 1 ? 's' : '') + ' to compare';
  bar.classList.add('is-visible');
}

function initCardActions() {
  syncActionButtons();

  document.addEventListener('click', function (event) {
    var actionEl = event.target.closest('[data-shajar-action]');
    if (!actionEl) return;

    var action = actionEl.getAttribute('data-shajar-action');

    if (action === 'quick-add') {
      event.preventDefault();
      var submitId = actionEl.getAttribute('data-quick-add-id');
      var submitBtn = submitId ? document.getElementById(submitId) : null;
      if (submitBtn) {
        submitBtn.click();
      } else {
        var link = actionEl.closest('.card-wrapper');
        var productLink = link ? link.querySelector('a[id^="CardLink-"]') : null;
        if (productLink) window.location.href = productLink.href;
      }
      return;
    }

    if (action === 'wishlist') {
      event.preventDefault();
      toggleInStore(SHAJAR_WISHLIST_KEY, productPayload(actionEl));
      syncActionButtons();
      return;
    }

    if (action === 'compare') {
      event.preventDefault();
      toggleInStore(SHAJAR_COMPARE_KEY, productPayload(actionEl), SHAJAR_COMPARE_MAX);
      syncActionButtons();
    }
  });
}

/* ---------- Countdown overlays ---------- */
function initCountdowns() {
  var nodes = document.querySelectorAll('[data-shajar-countdown]');
  if (!nodes.length) return;

  function tick() {
    var now = Math.floor(Date.now() / 1000);
    nodes.forEach(function (node) {
      var end = parseInt(node.getAttribute('data-end'), 10);
      if (!end || end <= now) {
        node.classList.add('is-ended');
        return;
      }
      var diff = end - now;
      var days = Math.floor(diff / 86400);
      var hours = Math.floor((diff % 86400) / 3600);
      var mins = Math.floor((diff % 3600) / 60);
      var secs = diff % 60;
      var pad = function (n) {
        return n < 10 ? '0' + n : String(n);
      };
      node.querySelector('[data-days]').textContent = pad(days);
      node.querySelector('[data-hours]').textContent = pad(hours);
      node.querySelector('[data-mins]').textContent = pad(mins);
      node.querySelector('[data-secs]').textContent = pad(secs);
    });
  }

  tick();
  setInterval(tick, 1000);
}

/* ---------- Judge.me write-review: unlock Next when text exists ----------
   Judge.me's popup sometimes leaves "Next" greyed out even after text is
   typed. We poll in the background (never on keystroke events, to avoid
   any risk of interfering with typing) and simply remove the disabled
   state from the Next control once the textarea has content.
*/
function initJudgeMeReviewUnlock() {
  if (window.__shajarJudgeMeUnlock) return;
  window.__shajarJudgeMeUnlock = true;

  function isNextControl(el) {
    if (!el || el.nodeType !== 1) return false;
    var label = ((el.textContent || '') + '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (label !== 'next') return false;
    if (el.children && el.children.length > 3) return false;
    return true;
  }

  function unlockAll() {
    var modals = document.querySelectorAll(
      '.jdgm-write-review-modal, .jdgm-ask-for-review-modal, [class*="jdgm-write-review-modal"]'
    );
    var anyOpen = false;

    modals.forEach(function (modal) {
      var style = window.getComputedStyle(modal);
      if (style.display === 'none' || style.visibility === 'hidden' || modal.getAttribute('aria-hidden') === 'true') {
        return;
      }
      anyOpen = true;

      var ta = modal.querySelector('textarea');
      if (!ta || !(ta.value || '').trim()) return;

      modal.querySelectorAll('button, a, [role="button"], div, span').forEach(function (el) {
        if (!isNextControl(el)) return;

        el.removeAttribute('disabled');
        if ('disabled' in el) el.disabled = false;
        el.setAttribute('aria-disabled', 'false');
        el.classList.remove('disabled', 'jdgm-disabled', 'jdgm-btn--disabled', 'is-disabled');
        el.style.setProperty('pointer-events', 'auto', 'important');
        el.style.setProperty('opacity', '1', 'important');
        el.style.setProperty('cursor', 'pointer', 'important');
      });
    });

    return anyOpen;
  }

  /* Poll only while a write-review modal is open — pause otherwise to cut TBT */
  var timer = null;
  var stopAt = 0;
  function startPolling() {
    stopAt = Date.now() + 90000;
    if (timer) return;
    timer = setInterval(function () {
      var open = unlockAll();
      if (!open && Date.now() > stopAt) {
        clearInterval(timer);
        timer = null;
      }
    }, 500);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target) return;
      if (e.target.closest('[data-shajar-write-review-btn], .jdgm-write-rev-link, .jdgm-write-rev-link *')) {
        startPolling();
      }
    },
    true
  );
}

/* ---------- Product page FOMO (live viewers / high demand) ---------- */
function initFomo() {
  document.querySelectorAll('[data-shajar-fomo]').forEach(function (node) {
    if (node.shajarFomoTimer) clearTimeout(node.shajarFomoTimer);

    var num = function (attr, fallback) {
      var value = parseInt(node.getAttribute(attr), 10);
      return isNaN(value) ? fallback : value;
    };
    var viewersMin = num('data-viewers-min', 30);
    var viewersMax = Math.max(viewersMin, num('data-viewers-max', 60));
    var soldMin = num('data-sold-min', 15);
    var soldMax = Math.max(soldMin, num('data-sold-max', 35));
    var realStock = num('data-real-stock', 0);
    var threshold = Math.max(1, num('data-stock-threshold', 10));

    /* Same numbers for a product all day, so a refresh doesn't reshuffle them */
    var seed = num('data-product-id', 1) + Math.floor(Date.now() / 86400000);
    var seeded = function (offset) {
      var x = Math.sin(seed + offset) * 10000;
      return x - Math.floor(x);
    };

    var sold = node.querySelector('[data-fomo-sold]');
    if (sold) sold.textContent = soldMin + Math.floor(seeded(1) * (soldMax - soldMin + 1));

    var bar = node.querySelector('[data-fomo-bar]');
    if (bar) {
      var width = realStock ? (realStock / threshold) * 30 : 14 + seeded(2) * 14;
      var barWidth = Math.max(8, Math.round(width)) + '%';
      /* Start from empty so the bar visibly fills once the box has risen in */
      setTimeout(function () { bar.style.width = barWidth; }, 700);
    }

    var viewers = node.querySelector('[data-fomo-viewers]');
    if (!viewers) return;
    var count = viewersMin + Math.floor(Math.random() * (viewersMax - viewersMin + 1));
    viewers.textContent = count;

    var drift = function () {
      var step = Math.floor(Math.random() * 7) - 3;
      var next = Math.min(viewersMax, Math.max(viewersMin, count + step));
      if (next !== count) {
        count = next;
        viewers.textContent = count;
        viewers.classList.remove('is-tick');
        void viewers.offsetWidth;
        viewers.classList.add('is-tick');
      }
      node.shajarFomoTimer = setTimeout(drift, 4000 + Math.random() * 5000);
    };
    node.shajarFomoTimer = setTimeout(drift, 4000);
  });
}
